import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BeforeYouStartComponent } from './before-you-start.component';
import { BeforeYouStartRoutingModule } from './before-you-start-routing.module';
import { MaterialModule } from 'src/app/shared/material.module';
import { ComponentsModule } from 'src/app/shared/components/components.module';


@NgModule({
  declarations: [
    BeforeYouStartComponent,
  ],
  imports: [
    CommonModule,
    BeforeYouStartRoutingModule,
    MaterialModule,
    ComponentsModule
  ]
})
export class BeforeYouStartModule { }
